import { Link } from "react-router-dom";
import { useTenantPath } from "@/lib/tenantPath";
import { MessageCircle, X, ArrowRight } from "lucide-react";

/**
 * WhatsappGateModal
 * Just-in-time gate rendered when the user tries to send WhatsApp invites
 * from an event but the agency's WABA isn't connected yet.
 * Follows the wording defined in the operational UX spec.
 */
export default function WhatsappGateModal({ open, onClose }) {
  const tPath = useTenantPath();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" data-testid="wa-gate-modal">
      <div className="bg-white rounded-2xl w-full max-w-md p-6 space-y-4 shadow-xl">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-700 flex items-center justify-center">
              <MessageCircle className="w-5 h-5" />
            </div>
            <div>
              <h2 className="font-display text-xl font-bold text-zinc-950">Liga o WhatsApp para enviar convites</h2>
            </div>
          </div>
          <button onClick={onClose} className="text-zinc-400 hover:text-zinc-700 p-1 rounded-md hover:bg-zinc-100" data-testid="wa-gate-close">
            <X className="w-4 h-4" />
          </button>
        </div>

        <p className="text-sm text-zinc-600 leading-relaxed">
          Usa o número WhatsApp Business da tua agência.
          Depois de ligado, poderás enviar e acompanhar convites diretamente na PromoCrew.
        </p>

        <div className="flex gap-2 pt-2 border-t border-zinc-100">
          <Link
            to={tPath("/configuracoes/whatsapp")}
            data-testid="wa-gate-connect-cta"
            className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2.5 rounded-lg text-sm font-semibold"
          >
            <MessageCircle className="w-4 h-4" /> Ligar WhatsApp <ArrowRight className="w-4 h-4" />
          </Link>
          <button
            onClick={onClose}
            data-testid="wa-gate-cancel"
            className="px-4 py-2.5 rounded-lg border border-zinc-200 text-sm hover:bg-zinc-50"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
